import React from 'react';
import { FaInstagram, FaYoutube, FaFacebook, FaLinkedin,FaTiktok } from 'react-icons/fa';
import './Css/Footer.css'; // For custom CSS

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="container py-5">
        {/* Main Footer Content */}
        <div className="row g-4">
          {/* Brand Column */}
          <div className="col-md-4">
            <div className="footer-brand">
              <h2 className="mb-3 brand-name">Tech Shara</h2>
              <p className="brand-tagline">Where innovation meets elegance</p>
              <div className="social-icons mt-4">
                <a href="https://www.instagram.com/akashgc.21/" className="social-icon"><FaInstagram /></a>
                <a href="https://www.youtube.com/@akashgc21" className="social-icon"><FaYoutube /></a>
                <a href="https://www.linkedin.com/in/akashgc/" className="social-icon"><FaFacebook /></a>
                <a href="https://www.tiktok.com/@akashgc.54" className="social-icon"><FaTiktok /></a>
                <a href="https://www.linkedin.com/in/akashgc/" className="social-icon"><FaLinkedin /></a>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          <div className="col-md-2 col-6">
            <h5 className="footer-heading">Explore</h5>
            <ul className="footer-links">
              <li><a href="#">Features</a></li>
              <li><a href="#">Solutions</a></li>
              <li><a href="#">Pricing</a></li>
              <li><a href="#">Case Studies</a></li>
            </ul>
          </div>

          <div className="col-md-2 col-6">
            <h5 className="footer-heading">Company</h5>
            <ul className="footer-links">
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Press</a></li>
            </ul>
          </div>

          <div className="col-md-4">
            <h5 className="footer-heading">Stay Updated</h5>
            <p className="newsletter-text">Subscribe to our newsletter for the latest updates</p>
            <div className="input-group mb-3 newsletter-input">
              <input 
                type="email" 
                className="form-control" 
                placeholder="Your email" 
                aria-label="Your email" 
              />
              <button className="btn btn-newsletter" type="button">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider my-4"></div>

        {/* Bottom Footer */}
        <div className="row">
          <div className="col-md-6">
            <p className="copyright-text">
              © {new Date().getFullYear()} Tech Shara. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <ul className="footer-legal-links">
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Cookies</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;